import { parse } from 'papaparse';

import type { DataType } from '../types';

import { hashData } from './dataHasher';

type PrepareDataToUploadParams = {
  file: File;
  dataType: DataType;
  chunkSize: number;
  onProcessedDataChunk: (recordsProcessed: number, dataToUpload: string[][]) => Promise<void>;
  onComplete: () => void;
  onError: (error: unknown) => void;
};

export function prepareDataToUpload({
  file,
  dataType,
  chunkSize,
  onProcessedDataChunk,
  onComplete,
  onError,
}: PrepareDataToUploadParams): void {
  let processingError: unknown;

  parse<string[]>(file, {
    chunk: async (results, parser) => {
      try {
        parser.pause();

        const data = await hashData(results.data, dataType);

        await onProcessedDataChunk(results.data.length, data);

        parser.resume();
      } catch (error) {
        processingError = error;
        parser.abort();
      }
    },
    chunkSize,
    complete: () => {
      if (processingError) {
        onError(processingError);
        return;
      }

      try {
        onComplete();
      } catch (e) {
        onError(e);
      }
    },
    skipEmptyLines: true,
  });
}
